import { create } from 'zustand';

/**
 * TDEV-1112 — whether `SettingsSync` has copied the admin's saved filters into
 * the filter stores, or `/settings` failed and the store defaults stand.
 *
 * Widget queries wait on this so an Overview load asks each endpoint once. The
 * flag flips in the same effect that writes the filter stores, so no render can
 * see it without the hydrated filters. Gating on the settings query itself is
 * not enough: a widget's `enabled` flip runs its fetch in a child effect, before
 * the parent `SettingsSync` effect has written the stores.
 *
 * It lasts one session: `SettingsSync` clears it on unmount, which a logout
 * causes, so the next login's widgets wait for that login's settings.
 */
export const useSettingsHydrationStore = create<{ hydrated: boolean }>()(() => ({
  hydrated: false,
}));
